import { errors as w3pErrors } from '@distributedlab/w3p';

export const errors = {
  ...w3pErrors,
};
